import React, { useEffect, useState } from "react";
import PageSeo from "../../components/seo/PageSeo";
import { Navigate } from "react-router-dom";
import { balanceHistoryCall } from "../../calls";
import Error from "../../components/Error/Error";
import { useTranslation } from "react-i18next";
import { fmtDate, fmtTime } from "../../utils/i18nFormat";
import "./balanceHistory.css";

/* BALANCE HISTORY — design "Signal" */
const BalanceHistory = (props) => {
  const {
    setIsLoggedIn, isLoggedIn,
    showErrorModal, setShowErrorModal, errorMsg, setErrorMsg,
    loader, setLoader,
  } = props;

  const [historyData, setHistoryData] = useState([]);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    setLoader(false);
    balanceHistoryCall()
      .then((response) => {
        setLoader(true);
        setHistoryData(Array.isArray(response.data) ? response.data : []);
      })
      .catch((err) => {
        setLoader(true);
        if (err.response && err.response.status === 401) {
          setIsLoggedIn(false);
          localStorage.removeItem("token");
        }
        setShowErrorModal(true);
        // Pas le message technique d'axios ("Request failed with status code 500")
        setErrorMsg([t("signal.t-try-again")]);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setIsLoggedIn, setErrorMsg, setShowErrorModal, setLoader]);

  if (!isLoggedIn) return <Navigate replace to="/" />;

  return (
    <div className="sg-page" style={{ maxWidth: 860 }}>
      <PageSeo noindex title={t("overview.balance-history")} />
      <div className="sg-panel">
        <div className="sg-head sg-head--center" style={{ marginBottom: 12 }}>
          <h1 className="sg-h1">{t("overview.balance-history")}</h1>
          <span className="sg-right" style={{ font: "400 12px var(--font-body)", color: "var(--color-muted)" }}>
            {historyData.length} {t("overview.entries-total")}
          </span>
        </div>
        {loader && (
          <div className="sg-table" style={{ "--cols": "60px 1fr 140px 120px" }}>
            <div className="sg-tr sg-tr--head">
              <span>{t("overview.id")}</span>
              <span>{t("overview.date")}</span>
              <span>{t("overview.time")}</span>
              <span className="sg-td--end">{t("overview.amount")}</span>
            </div>
            {historyData.length === 0 ? (
              <div className="sg-empty" style={{ border: "none", borderRadius: 0 }}>{t("signal.no-entries")}</div>
            ) : (
              historyData.map((item, index) => {
                const d = new Date(item.created_at);
                return (
                  <div key={index} className="sg-tr">
                    <span className="sg-td--mono">{index + 1}</span>
                    <span className="sg-td--mono">{fmtDate(d, { weekday: "short", year: "numeric", month: "short", day: "numeric" }, i18n.language)}</span>
                    <span className="sg-td--mono">{fmtTime(d, undefined, i18n.language)}</span>
                    <span
                      className="sg-td--end sg-price"
                      style={{ color: Number(item.amount) >= 0 ? "var(--color-success)" : "var(--color-ink)" }}
                    >
                      {Number(item.amount) >= 0 ? "+" : "−"}${Math.abs(Number(item.amount)).toFixed(2)}
                    </span>
                  </div>
                );
              })
            )}
          </div>
        )}
      </div>
      <Error
        showErrorModal={showErrorModal}
        setShowErrorModal={setShowErrorModal}
        errorMsg={errorMsg}
      />
    </div>
  );
};

export default BalanceHistory;
